export const GET_PLANTILLA_CUESTIONARIO = "GET_PLANTILLA_CUESTIONARIO";
export const LOADING_PLANTILLA_CUESTIONARIO = "LOADING_PLANTILLA_CUESTIONARIO";
export const SAVE_LOADER_PLANTILLA_CUESTIONARIO =
  "SAVE_LOADER_PLANTILLA_CUESTIONARIO";
export const PLANTILLA_CUESTIONARIO_FAIL = "PLANTILLA_CUESTIONARIO_FAIL";
export const FORM_FAIL = "FORM_FAIL";

// Para Modal import cuestionario
export const GET_PLANTILLA_CUESTIONARIO_IMPORT =
  "GET_PLANTILLA_CUESTIONARIO_IMPORT";
export const LOADING_PLANTILLA_CUESTIONARIO_IMPORT =
  "LOADING_PLANTILLA_CUESTIONARIO_IMPORT";
export const PLANTILLA_CUESTIONARIO_IMPORT_FAIL =
  "PLANTILLA_CUESTIONARIO_IMPORT_FAIL";
export const SAVE_LOADER_PLANTILLA_CUESTIONARIO_IMPORT =
  "SAVE_LOADER_PLANTILLA_CUESTIONARIO_IMPORT";
export const FORM_IMPORT_FAIL = "FORM_IMPORT_FAIL";

// Para preguntas plantilla cuestionario
export const GET_PLANTILLA_CUESTIONARIO_PREGUNTAS =
  "GET_PLANTILLA_CUESTIONARIO_PREGUNTAS";
export const LOADING_PLANTILLA_CUESTIONARIO_PREGUNTAS =
  "LOADING_PLANTILLA_CUESTIONARIO_PREGUNTAS";
export const PLANTILLA_CUESTIONARIO_PREGUNTAS_FAIL =
  "PLANTILLA_CUESTIONARIO_PREGUNTAS_FAIL";
export const SAVE_LOADER_PLANTILLA_CUESTIONARIO_PREGUNTAS =
  "SAVE_LOADER_PLANTILLA_CUESTIONARIO_PREGUNTAS";
export const GET_SAVE_PLANTILLA_CUESTIONARIO_IMPORT =
  "GET_SAVE_PLANTILLA_CUESTIONARIO_IMPORT";

// Para agregar preguntas
export const SAVE_LOADER_PLANTILLA_CUESTIONARIO_PREGUNTA =
  "SAVE_LOADER_PLANTILLA_CUESTIONARIO_PREGUNTA";
export const PLANTILLA_CUESTIONARIO_PREGUNTA_FAIL =
  "PLANTILLA_CUESTIONARIO_PREGUNTA_FAIL";
